import { Link } from 'react-router-dom';
import './Admitcard.css'
let Admitcard=(props)=>{
    let AdmitcardDownloadfun=(e)=>{
        props.callfunctionadmitcard(e);
    }
    return(
        <div className='maincontadmitcard'> 
        <div className='subcontadmitcard'>
            <h2 className='admitcardheading'>Admit Card</h2>
            { 
                props.singledata !== "" ? props.singledata.map(
                    dd=>(
                        dd.admitcarddownloadlink !== "na" ? <Link to="../AdmitcardDownload" onClick={()=>{AdmitcardDownloadfun(dd)}} className='jobslink' style={{display:"block"}}><li>{dd.jobtitle}</li></Link> : ""
                        
                        
                    )  
                ) : window.location = "/search-jobs.com"
            }
        </div>
        </div>
    );
}
export default Admitcard;